import React, { PureComponent } from 'react'
/**
 * This error boundary component can be used to wrap large content areas and
 * catch exceptions during rendering in the component tree below them.
 */
export default class ErrorBoundary extends PureComponent {
  static getDerivedStateFromError(error) {
    // Side effects are not permitted here, so we only update the state so
    // that the next render shows an error message.
    return { error }
  }

  constructor(props) {
    super(props)

    this.state = {
      error: null,
    }
  }

  componentDidCatch(error, { componentStack }) {
    // Browser consoles are better at formatting output when native errors are passed
    // in their own `console.error` invocation.
    // eslint-disable-next-line no-console
    console.error(error)
    // eslint-disable-next-line no-console
    console.error(
      'The above error occured while React was rendering the following components:',
      componentStack
    )
  }

  render() {
    if (this.state.error) {
      return (
        <div className="mx_ErrorBoundary">
          <div className="mx_ErrorBoundary_body">
            <h1>Something went wrong!</h1>
            <p>
              Our engineers has been notified of this issue. Please refresh the
              page or contact support if the issue persists
            </p>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
